import React from 'react'
import MyTable from '../../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../../../../UI/table/MyTableNotFound'
import SupplyOrderBillItemShort from './SupplyOrderBillItemShort'

const SupplyOrderBillItemsTableShort = ({ supplyOrderBillItems }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">№</TableCell>
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">Кількість</TableCell>
            </>
        }
        body={
            // supplyBillItems && supplyBillItems.length > 0 ?
            //     supplyBillItems.map((supplyBillItem, index) => 
            supplyOrderBillItems && supplyOrderBillItems.length > 0 ?
                supplyOrderBillItems.map((supplyBillItem, index) => 
                    <SupplyOrderBillItemShort
                        key={supplyBillItem.id}
                        index={index}
                        supplyBillItem={supplyBillItem} 
                        // checked={checked}
                        // setChecked={setChecked}
                    />
                )
            : 
                <MyTableNotFound
                    text='Позицій не знайдено' 
                    // columns={6}
                />
        }
        name='позицій'
        hidePagination={true}
    />
  )
}

export default SupplyOrderBillItemsTableShort